import React from 'react'
import LatinoTemplateDefault from 'src/components/template/us/'
import { sportIds, leagueIds } from 'src/constants/personalizationIds'

export default (props) => {
  return (
    <LatinoTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      video="https://assets.fubo.tv/marketing/lp/videos/compressed/mls-espn-deportes-22sec.mp4"
      title="Watch MLS on ESPN Deportes"
      subtitle="Live matches, league analysis and more"
      networkSet="soccer"
      customNetworks={['espndeportes']}
      sportId={sportIds.Soccer}
      leagueId={leagueIds['MLS']}
    />
  )
}
